/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Tooltip } from '@airbus/components-react';
import { Info, InfoOutline } from '@airbus/icons/react';
import './InfoTooltip.scss';

const InfoTooltip = (props: any) => {
  const { classname, labeltext, infoClassname } = props;
  return (
    <div className="tool-tip-new">
      <Tooltip
        placement="bottom"
        label={labeltext}
        className={classname}
        data-testid="tooltip-info"
      >
        {infoClassname ? <Info className={infoClassname} />
          : <InfoOutline />}
      </Tooltip>
    </div>
  );
};

export default InfoTooltip;
